import { CommonModule } from '@angular/common';
import { Component, Input, SecurityContext } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import Swal from 'sweetalert2';
import { CurrentFacilityService } from '../../services';

@Component({
    standalone: true,
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss'],
    imports: [RouterModule, CommonModule, MatButtonModule, MatListModule],
})
export class HeaderItemComponent {
    public safeUrl: SafeResourceUrl | undefined;
    public isExternalLink = false;

    @Input() idRedirect: string = '';
    @Input() routerLinkURL: string | string[];
    @Input() set externalLink(link: string) {
        if (link) {
            this.isExternalLink = true;
        }
        this.safeUrl = link && this.sanitizer.bypassSecurityTrustResourceUrl(link);
    }
    @Input() matButton = false;
    @Input() matListItem = false;

    constructor(
        private sanitizer: DomSanitizer,
        private currentFacilityService: CurrentFacilityService
    ) {}

    redirectExternalLink(event: Event): void {
        const sanitizedUrl: string = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.safeUrl || '') ?? '';
        const facility = this.currentFacilityService.getFacilityName();
        event.preventDefault();
        Swal.fire({
            icon: 'info',
            title: `Redirecting to ${facility} Portal`,
            text: ` We will sending you over to the ${facility} portal.`,
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Close',
            allowOutsideClick: false,
            reverseButtons: true,
        }).then((result): void => {
            if (result.isConfirmed) {
                window.open(sanitizedUrl, '_blank');
            }
        });
    }
}
